
export class SEODetector {
  public static detectOrphanedUrls(): string[] {
    // URLs potentiellement orphelines basées sur les redirections
    const orphanedUrls = [
      '/ancien-site',
      '/old-contact',
      '/vieux-services',
      '/beta',
      '/test',
      '/demo.html',
      '/contact.php',
      '/services.php'
    ];

    return orphanedUrls;
  }

  public static detectDuplicateContent(): { original: string; duplicates: string[] }[] {
    return [
      {
        original: '/nos-services/location-bennes',
        duplicates: [
          '/location-bennes',
          '/services/location-bennes',
          '/bennes'
        ]
      },
      {
        original: '/nos-services/achat-metaux',
        duplicates: [
          '/achat-metaux',
          '/services/achat-metaux',
          '/metaux'
        ]
      },
      {
        original: '/contact',
        duplicates: [
          '/contact.html',
          '/nous-contacter',
          '/contact-form'
        ]
      }
    ];
  }
}
